<template>
  <v-card class="card-wrap">
    <v-container
      fluid
      :class="[
        'pt-6',
        'body-2',
        'card-layout',
        confirmationState === 'register' ? 'heightNotFull' : 'heightFull',
      ]"
    >
      <v-icon
        v-if="confirmationState !== 'register' || stateRegistration === 2"
        style="position: absolute; right: 2vw; top: 1.5vw; z-index: 10;"
        @click="onCloseButtonClick"
        >mdi-close</v-icon
      >

      <!-- Register Header -->
      <div
        v-if="
          state === 'order' &&
            confirmationState === 'register' &&
            activityStatus !== 'detail-register'
        "
      >
        <div v-if="stateRegistration === 0">
          <h2 class="title">Pendaftaran Pasien</h2>
        </div>

        <div v-if="stateRegistration === 1">
          <div class="header px-9">
            <div class="d-flex justify-space-between align-center">
              <h2 class="ma-0 pa-0">Permintaan Pemeriksaan Laboratorium</h2>
              <v-btn small fab dense text @click="onCloseButtonClick">
                <v-icon color="#757575">mdi-close</v-icon>
              </v-btn>
            </div>
            <div class="d-flex justify-start align-center">
              <p class="ma-0 pa-0 label">No RM</p>
              <p class="ma-0 pa-0 data">
                {{
                  patientRegistration('rmNumber') !== ''
                    ? patientRegistration('rmNumber')
                    : generatedRmNumber
                }}
              </p>
              <p class="ma-0 pa-0 label">Nama</p>
              <p class="ma-0 pa-0 data">
                {{ patientRegistration('name') }} ({{
                  patientRegistration('gender') ? 'L' : 'P'
                }})
              </p>
              <p class="ma-0 pa-0 label">Tanggal Lahir</p>
              <p class="ma-0 pa-0 data">
                {{ formatDateTime(patientRegistration('birthDate')) }} ({{
                  patientRegistration('age')
                }})
              </p>
              <p class="ma-0 pa-0 label">Petugas</p>
              <p class="ma-0 pa-0 data">-</p>
              <p class="ma-0 pa-0 label">Unit</p>
              <p class="ma-0 pa-0 data">test</p>
            </div>
          </div>
        </div>

        <div v-if="stateRegistration === 2">
          <span class="black--text font-weight-bold headline mr-8">
            Detail Permintaan Pemeriksaan Laboratorium
          </span>
          <div class="d-flex justify-center align-center detail-header">
            <div>
              <span>No RM</span>
              <span class="black--text font-weight-bold mx-3">{{
                patientRegistration('rmNumber') !== ''
                  ? patientRegistration('rmNumber')
                  : generatedRmNumber
              }}</span>
            </div>
            <div>
              <span>Nama</span>
              <span class="black--text font-weight-bold mx-3"
                >{{ patientRegistration('name') }} ({{
                  patientRegistration('gender') ? 'L' : 'P'
                }})</span
              >
            </div>
            <div>
              <span>Tanggal Lahir</span>
              <span class="black--text font-weight-bold mx-3">
                {{ formatDateTime(patientRegistration('birthDate')) }} ({{
                  patientRegistration('age')
                }})
              </span>
            </div>
            <div>
              <span>Asal Poli</span>
              <span class="black--text font-weight-bold mx-3">Pendaftaran</span>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="
          state === 'detail' ||
            confirmationState === 'confirmation' ||
            (activityStatus === 'detail-register' &&
              confirmationState === 'register')
        "
      >
        <span class="black--text font-weight-bold headline mr-8">
          Detail Permintaan Pemeriksaan Laboratorium
        </span>
        <div class="d-flex justify-center align-center detail-header">
          <div>
            <span>No RM</span>
            <span class="black--text font-weight-bold mx-3">{{
              dataLab === undefined
                ? getPatientData?.rmNumber
                : dataLab?.patient?.rmNumber
            }}</span>
          </div>
          <div>
            <span>Nama</span>
            <span class="black--text font-weight-bold mx-3"
              >{{
                dataLab === undefined
                  ? getPatientData?.meta?.name
                  : dataLab?.patient?.name
              }}
              ({{
                dataLab === undefined
                  ? getPatientData?.meta?.gender === 'Laki-laki'
                    ? 'L'
                    : 'P'
                  : dataLab?.patient?.gender
              }})</span
            >
          </div>
          <div>
            <span>Tanggal Lahir</span>
            <span class="black--text font-weight-bold mx-3"
              >{{
                formatDateTime(
                  dataLab === undefined
                    ? getPatientData?.meta?.birthDateUnformatted
                    : dataLab?.patient?.birthDate,
                )
              }}
              ({{ ageFormatted }})
            </span>
          </div>
          <div
            v-if="
              activityStatus !== 'detail-register' &&
                confirmationState !== 'register'
            "
          >
            <span>Petugas</span>
            <span class="black--text font-weight-bold mx-3">{{
              dataLab === undefined
                ? labByReqId?.staff?.name === undefined
                  ? '-'
                  : labByReqId?.staff?.name
                : dataLab.staff
            }}</span>
          </div>
          <div>
            <span>Asal Poli</span>
            <span class="black--text font-weight-bold mx-3">{{
              dataLab === undefined
                ? getPatientData?.meta?.polyName
                : dataLab.polyName
            }}</span>
          </div>
        </div>
      </div>

      <div
        v-if="
          state === 'order' &&
            confirmationState !== 'confirmation' &&
            confirmationState !== 'register'
        "
      >
        <div style="text-align: start;" class="px-8 mb-2">
          <span style="color: #404040; font-weight: 700; font-size: 18px;">
            Hasil Pemeriksaan Laboratorium
          </span>
        </div>
        <v-row no-gutters class="card-layout__header px-8">
          <v-col cols="12" align-self="center" class="text-left">
            <div
              style="display: flex; justify-content: flex-start; align-items: center; gap: 1rem;"
            >
              <div>
                <span class="text-key">No RM</span>
                <span class="text-value mx-4">{{
                  dataLab === undefined
                    ? getPatientData?.rmNumber
                    : dataLab?.patient?.rmNumber
                }}</span>
              </div>

              <div>
                <span class="text-key">Nama</span>
                <span class="text-value mx-4"
                  >{{
                    dataLab === undefined
                      ? getPatientData?.meta?.name
                      : dataLab?.patient?.name
                  }}
                  ({{
                    dataLab === undefined
                      ? getPatientData?.meta?.gender === 'Laki-laki'
                        ? 'L'
                        : 'P'
                      : dataLab?.patient?.gender
                  }})</span
                >
              </div>

              <div>
                <span class="text-key">Tanggal Lahir</span>
                <span class="text-value mx-4"
                  >{{
                    formatDateTime(
                      dataLab === undefined
                        ? getPatientData?.meta?.birthDateUnformatted
                        : dataLab?.patient?.birthDate,
                    )
                  }}
                  ({{ ageFormatted }})</span
                >
              </div>
              <div>
                <span class="text-key">Unit</span>
                <span class="text-value mx-4">{{
                  dataLab === undefined
                    ? getPatientData?.meta?.polyName
                    : dataLab.polyName
                }}</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>

      <!-- Registration -->
      <template
        v-if="
          confirmationState === 'register' &&
            activityStatusLab !== 'detail-register'
        "
      >
        <div v-if="stateRegistration === 0" class="px-8 py-8">
          <SocialDataPatientsLaboratory ref="patient" />
        </div>
        <div v-if="stateRegistration === 1" class="px-8 py-8">
          <OrderExaminationTab ref="order" state="register" />
        </div>
        <div v-if="stateRegistration === 2" class="px-8 py-8">
          <DetailExaminationTab
            ref="update"
            :assurance="patientRegistration('assuranceType')"
          />
        </div>
      </template>

      <template
        v-if="
          confirmationState === 'register' &&
            activityStatusLab === 'detail-register'
        "
      >
        <div class="py-8">
          <v-divider></v-divider>
          <div class="px-8 py-8">
            <DetailExaminationTab />
          </div>
        </div>
      </template>

      <!-- Confirmation -->
      <template v-if="confirmationState === 'confirmation'">
        <div class="py-8">
          <v-divider></v-divider>
          <div class="px-8 py-8">
            <div
              v-if="dataLab?.isConfirmed"
              class="text-start"
              style="width: 200px;"
            >
              <v-alert
                dense
                text
                type="success"
                style=" border: 0.5px solid #BDBDBD;"
              >
                <span
                  style="color: #404040; font-weight: 400; font-size: 14px;"
                >
                  Sudah Dikonfirmasi
                </span>
              </v-alert>
            </div>
            <DetailExaminationTab
              :confirmation-state="'confirmation'"
              ref="detailConfirmation"
              :isConfirmed="dataLab?.isConfirmed"
            />
          </div>
        </div>
      </template>

      <!-- Result -->
      <template v-if="confirmationState === 'result'">
        <div class="py-4">
          <v-divider></v-divider>
          <div class="px-8 py-4">
            <ResultExaminationTab
              :stateIsFinished="activityStatusLab"
              stateResult="result"
              ref="result"
            />
          </div>
        </div>
      </template>

      <!-- Order Not shceduled -->
      <template v-if="activityStatusLab === 'not_scheduled'">
        <div v-if="state === 'detail'">
          <div class="py-8">
            <v-divider></v-divider>
            <div class="px-8 py-8">
              <DetailExaminationTab />
            </div>
          </div>
        </div>
        <div v-if="state === 'order'">
          <v-main class="py-8 container-layout px-16">
            <v-tabs grow v-model="tabs">
              <v-tab class="text-none w-100"
                >Order Permintaan Laboratorium</v-tab
              >
              <v-tab class="text-none">Hasil Pemeriksaan Laboratorium</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs" class="pt-6">
              <v-tab-item><OrderExaminationTab ref="order"/></v-tab-item>
              <v-tab-item
                ><ResultExaminationTab
                  :stateIsFinished="activityStatusLab"
                  stateResult="request"
              /></v-tab-item>
            </v-tabs-items>
          </v-main>
        </div>
      </template>

      <!-- Order Scheduled but not confirmed -->
      <template v-else-if="activityStatusLab === 'scheduled'">
        <v-main class="py-8 container-layout px-16">
          <v-tabs grow v-model="tabs">
            <v-tab class="text-none w-100"
              >Detail Permintaan Laboratorium</v-tab
            >
            <v-tab class="text-none">Hasil Pemeriksaan Laboratorium</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs" class="pt-4">
            <v-tab-item class="py-4"
              ><DetailExaminationTab ref="update"
            /></v-tab-item>
            <v-tab-item
              ><ResultExaminationTab
                :stateIsFinished="activityStatusLab"
                stateResult="request"
            /></v-tab-item>
          </v-tabs-items>
        </v-main>
        <v-snackbar
          light
          content-class="font-weight-medium pr-0"
          :value="snackbar.show"
          elevation="0"
          :color="snackbar.color"
          height="15"
        >
          <div class="d-flex justify-space-between align-center">
            <span style="color: white">
              {{ snackbar.text }}
            </span>
            <v-btn
              style="color: white"
              text
              fab
              small
              right
              @click="snackbar.show = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </div>
        </v-snackbar>
      </template>

      <!-- Order Confirmed -->
      <template v-else-if="activityStatusLab === 'confirmed'">
        <v-main class="py-8 container-layout px-16">
          <v-tabs grow v-model="tabs">
            <v-tab class="text-none w-100"
              >Detail Permintaan Laboratorium</v-tab
            >
            <v-tab class="text-none">Hasil Pemeriksaan Laboratorium</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs" class="pt-4">
            <v-tab-item class="py-4"><DetailExaminationTab /></v-tab-item>
            <v-tab-item
              ><ResultExaminationTab
                :stateIsFinished="activityStatusLab"
                stateResult="request"
            /></v-tab-item>
          </v-tabs-items>
        </v-main>
      </template>
    </v-container>
    <v-card-actions color="white" class="card-footer">
      <div v-if="state === 'detail'">
        <v-btn
          outlined
          color="secondary"
          class="text-none rounded"
          tile
          @click="handleSetState('order')"
        >
          Kembali
        </v-btn>
      </div>
      <span
        v-if="
          confirmationState === 'register' &&
            activityStatusLab === 'detail-register'
        "
      >
        <v-btn
          text
          color="secondary"
          class="text-none rounded mr-4"
          tile
          @click="handleBackRegistration"
        >
          Kembali
        </v-btn>
      </span>
      <div v-if="state !== 'detail'"></div>
      <div>
        <span
          v-if="
            confirmationState !== 'register' ||
              (confirmationState === 'register' &&
                activityStatusLab === 'detail-register')
          "
        >
          <v-btn
            v-if="confirmationState !== 'confirmation'"
            :outlined="
              confirmationState === 'result' && dataLab?.isFinished === true
            "
            color="primary"
            class="text-none rounded mr-4"
            tile
            :disabled="printDisable"
            depressed
            @click="printResult()"
          >
            Print{{
              activityStatusLab === 'detail-register'
                ? ' Hasil Laboratorium'
                : ''
            }}
          </v-btn>
        </span>
        <span
          v-if="
            confirmationState === 'register' &&
              activityStatusLab !== 'detail-register'
          "
        >
          <v-btn
            text
            color="secondary"
            class="text-none rounded mr-4"
            tile
            @click="handleBackRegistration"
          >
            Kembali
          </v-btn>
        </span>
        <span v-if="dataLab?.isFinished !== true">
          <v-btn
            :outlined="
              confirmationState === 'register' && stateRegistration !== 2
            "
            :disabled="onState()?.disabled"
            v-if="
              (tabs === 0 && activityStatusLab !== 'confirmed') ||
                confirmationState === 'confirmation' ||
                confirmationState === 'result' ||
                (confirmationState === 'register' &&
                  activityStatusLab !== 'detail-register')
            "
            color="primary"
            depressed
            tile
            class="text-none rounded"
            @click="onState()?.method()"
            >{{ onState()?.buttonText }}</v-btn
          >
        </span>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment-timezone';

import Constant from '@/const';
import printMixin from '@/mixin/printMixin';
import formatMixin from '@/mixin/formatMixin';
import AlertMixin from '@/mixin/alertMixin';
import { scrollToEmptyInput } from '@/helper';
import OrderExaminationTab from './OrderExaminationTab.vue';
import DetailExaminationTab from './DetailExaminationTab.vue';
import ResultExaminationTab from './ResultExaminationTab.vue';
import printLaboratoryResult from '@/mixin/printLaboratoryResult.js';
import SocialDataPatientsLaboratory from '../../../Registration/components/SocialDataPatientsLaboratory.vue';

import { createNamespacedHelpers } from 'vuex';
const {
  mapGetters: labGetters,
  mapActions: labActions,
  mapMutations: labMutations,
} = createNamespacedHelpers('ExaminationLaboratory');
const {
  mapGetters: patientGetters,
  mapMutations: patientMutations,
} = createNamespacedHelpers('PatientRegistration');

export default {
  name: 'ExaminationDialogV2',
  mixins: [AlertMixin, printMixin, formatMixin, printLaboratoryResult],
  components: {
    OrderExaminationTab,
    ResultExaminationTab,
    DetailExaminationTab,
    SocialDataPatientsLaboratory,
  },
  computed: {
    ...labGetters([
      'getInputOrderCheckedItems',
      'getProvisionalDiagnosis',
      'getPatientData',
      'getShowDialog',
      'getActivityStatusLab',
      'getSnackbar',
      'getIsChanged',
      'getInputResultIsChanged',
      'getStateRegistration',
      'getLabReqById',
      'getLabResultById',
    ]),
    ...patientGetters(['getPatientRegistration', 'getGeneratedRmNumber']),
    inputOrderCheckedItems: {
      get() {
        return this.getInputOrderCheckedItems;
      },
    },
    stateRegistration: {
      get() {
        return this.getStateRegistration;
      },
    },
    printDisable() {
      return (
        (this.confirmationState === 'result' &&
          this.labResult?.isInputed === false) ||
        (this.activityStatusLab === 'confirmed' &&
          this.labByReqId?.isInputed === false) ||
        this.activityStatusLab === 'scheduled' ||
        this.activityStatusLab === 'not_scheduled' ||
        (this.activityStatusLab === 'detail-register' &&
          this.labByReqId?.isInputed === false)
      );
    },
    provisionalDiagnosis: {
      get() {
        return this.getProvisionalDiagnosis;
      },
    },
    showDialog: {
      get() {
        return this.getShowDialog;
      },
    },
    activityStatusLab: {
      get() {
        return this.getActivityStatusLab;
      },
      set(value) {
        this.setActivityStatusLab(value);
      },
    },
    snackbar: {
      get() {
        return this.getSnackbar;
      },
      set(value) {
        this.setSnackbar(value);
      },
    },
    isChanged: {
      get() {
        return this.getIsChanged;
      },
    },
    inputResultIsChanged: {
      get() {
        return this.getInputResultIsChanged;
      },
    },
    labByReqId: {
      get() {
        return this.getLabReqById;
      },
    },
    labResult: {
      get() {
        return this.getLabResultById;
      },
    },
    letterData() {
      return Constant.client.find(
        item =>
          item.name.toLowerCase() ===
          this.$store.getters.userLoggedIn.clinic.name.toLowerCase(),
      );
    },
    patientRegistration() {
      return function(key) {
        return this.getPatientRegistration[key];
      };
    },
    generatedRmNumber: {
      get() {
        return this.getGeneratedRmNumber;
      },
    },
    ageFormatted() {
      const date = this.formatDateTime(
        this.dataLab === undefined
          ? this.getPatientData?.meta?.birthDateUnformatted
          : this.dataLab?.patient?.birthDate,
      );
      return this.ageDuration(moment(date, 'DD MMMM YYYY'));
    },
  },
  props: {
    patientData: Object,
    activityStatus: String,
    confirmationState: String,
    dataLab: Object,
    stateResult: String,
  },
  data() {
    return {
      tabs: null,
      state: 'order',
    };
  },
  mounted() {
    this.clearSnackbar();
    this.setPatientData(this.patientData);
    this.setActivityStatusLab(this.activityStatus);
  },
  watch: {
    showDialog: {
      deep: true,
      handler() {
        if (!this.showDialog) {
          this.$emit('close-dialog');
          this.clearState();
        }
      },
    },
  },
  methods: {
    ...labMutations([
      'clearState',
      'setPatientData',
      'setShowDialog',
      'setActivityStatusLab',
      'setStateRegistration',
      'setSnackbar',
      'clearSnackbar',
    ]),
    ...patientMutations(['clearStatePatientRegistration']),
    ...labActions([
      'resolvePostOrderExamination',
      'resolveUpdateLabRequest',
      'resolveConfirmLabRequest',
      'resolvePostLabResult',
      'resolvePostLabRegistration',
    ]),
    toNewOrder() {
      this.setStateRegistration(1);
    },
    onState() {
      switch (this.confirmationState) {
        case 'register':
          switch (this.state) {
            case 'order':
              switch (this.stateRegistration) {
                case 0:
                  return {
                    method: this.handleContinueRegistration,
                    buttonText: 'Lanjut',
                    disabled: false,
                  };
                case 1:
                  return {
                    disabled: this.inputOrderCheckedItems?.length === 0,
                    method: this.handleContinueRegistration,
                    buttonText: 'Lanjut',
                  };
                case 2:
                  return {
                    method: this.handlePostRegistration,
                    buttonText: 'Order',
                    disabled: false,
                  };
              }
              break;
          }
          break;
        case 'order':
          switch (this.activityStatusLab) {
            case 'not_scheduled':
              switch (this.state) {
                case 'order':
                  switch (this.tabs) {
                    case 0: {
                      return {
                        disabled: this.inputOrderCheckedItems?.length === 0,
                        method: this.handleContinueOrderExamination,
                        buttonText: 'Lanjut',
                      };
                    }
                    case 1: {
                      return {
                        disabled: false,
                        method: this.handleContinueResultExamination,
                      };
                    }
                  }
                  break;
                case 'detail':
                  return {
                    disabled: false,
                    method: this.handlePostOrderExamination,
                    buttonText: 'Order',
                  };
                default:
                  break;
              }
              break;
            case 'scheduled':
              return {
                disabled: !this.isChanged,
                method: this.handleUpdateLabRequest,
                buttonText: 'Simpan Perubahan',
              };
          }
          break;
        case 'confirmation':
          switch (this.dataLab.isConfirmed) {
            case true: {
              return {
                disable: false,
                method: this.onCloseButtonClick,
                buttonText: 'Kembali',
              };
            }
            case false: {
              return {
                disabled: false,
                method: this.handleConfirmationLabRequest,
                buttonText: 'Konfirmasi',
              };
            }
          }
          break;
        case 'result':
          switch (this.labResult.isInputed) {
            case false:
              return {
                disabled: this.inputResultIsChanged,
                method: this.handleSaveResultExamination,
                buttonText: 'Simpan',
              };
            case true:
              return {
                disabled: this.inputResultIsChanged,
                method: this.handleSaveResultExamination,
                buttonText: 'Simpan Perubahan',
              };
            default:
              break;
          }
      }
    },
    handleSetState(state) {
      this.state = state;
    },
    onCloseButtonClick() {
      this.clearState();
      this.setShowDialog(false);
      this.$emit('close-dialog');
    },
    formatDateTime(date) {
      const expectedFormat = 'DD MMMM YYYY';
      const inputFormats = ['DD/MM/YYYY', 'YYYY-MM-DD', 'DD-MM-YYYY'];

      // If already valid and in the expected format, return it
      if (moment(date, expectedFormat, true).isValid()) {
        return date;
      }

      // Try parsing other formats
      const parsed = moment(date, inputFormats, true);
      return parsed.isValid() ? parsed.format(expectedFormat) : '';
    },
    async handleContinueOrderExamination() {
      if (await this.$refs.order.$refs.form.validate()) {
        this.handleSetState('detail');
      } else {
        scrollToEmptyInput();
      }
    },
    handleUpdateLabRequest() {
      if (this.$refs.update.$refs.form.validate()) {
        this.resolveUpdateLabRequest();
      }
    },
    handleContinueResultExamination() {},
    handleConfirmationLabRequest() {
      if (this.$refs.detailConfirmation.$refs.form.validate()) {
        this.resolveConfirmLabRequest();
      }
    },
    handleSaveResultExamination() {
      if (this.$refs.result.$refs.formResult.validate()) {
        this.resolvePostLabResult({ isInputed: this.dataLab.isInputed });
      }
    },
    handlePostOrderExamination() {
      this.resolvePostOrderExamination();
      this.clearStatePatientRegistration();
    },
    handleBackRegistration() {
      if (
        !this.patientRegistration('statusIsNew') &&
        this.stateRegistration === 1
      ) {
        this.$emit('open-history-lab-order');
        return;
      }
      if (this.stateRegistration === 0) {
        this.$emit('close-dialog');
        this.clearState();
        this.clearStatePatientRegistration();
      } else {
        this.clearState();
        this.setStateRegistration(this.stateRegistration - 1);
      }
    },
    handleContinueRegistration() {
      if (this.stateRegistration === 1) {
        if (this.$refs.order.$refs.form.validate()) {
          this.setStateRegistration(this.stateRegistration + 1);
        }
        this.setActivityStatusLab('registration');
      } else {
        if (!this.$refs.patient.$refs.form.validate()) {
          this.$refs.patient.checkRules();
          return;
        }
        this.$emit('open-history-lab-order');
        if (this.patientRegistration('statusIsNew')) {
          this.setStateRegistration(this.stateRegistration + 1);
          return;
        }
      }
    },
    async handlePostRegistration() {
      const patientData = {
        id_emr: this.patientRegistration('idEmr'),
        status: {
          isNew: this.patientRegistration('statusIsNew'),
          type: this.patientRegistration('statusType'),
        },
        meta: {
          name: this.patientRegistration('name'),
          nickname: this.patientRegistration('nickname'),
          phone_number: this.patientRegistration('phoneNumber'),
          gender: this.patientRegistration('gender'),
          birth: {
            date: this.patientRegistration('birthDate'),
            place: this.patientRegistration('birthPlace'),
          },
          address: {
            district: this.patientRegistration('addressDistrict')?.name || '',
            province: this.patientRegistration('addressProvince')?.name || '',
            sub_district:
              this.patientRegistration('addressSubDistrict')?.name || '',
            text: this.patientRegistration('addressText'),
            city: this.patientRegistration('addressCity')?.name || '',
          },
          identity: {
            type: this.patientRegistration('identityType'),
            number: this.patientRegistration('identityNumber'),
          },
          religion: this.patientRegistration('religion'),
          blood_type: this.patientRegistration('bloodType'),
          education: this.patientRegistration('education'),
          ethnicity: this.patientRegistration('ethnicity'),
          profession: this.patientRegistration('profession'),
          martial_status: this.patientRegistration('martialStatus'),
          father: this.patientRegistration('father'),
          mother: this.patientRegistration('mother'),
          disabilities: this.patientRegistration('disabilities'),
          communication_obstacles: this.patientRegistration(
            'communicationObstacles',
          ),
          language_mastering: this.patientRegistration('languageMastering'),
          assurance: {
            type: this.patientRegistration('assuranceType'),
            name: this.patientRegistration('assuranceName'),
            number: this.patientRegistration('assuranceNumber'),
            isProlanis: this.patientRegistration('assuranceIsProlanis'),
          },
        },
      };
      await this.resolvePostLabRegistration(patientData);
    },
    dataPrint() {
      if (this.patientData === undefined) {
        const {
          staff,
          clinical_notes,
          recommendation,
          test_item,
          timestamps,
        } = this.labResult;
        const { guarantorType, patient, orderNumber } = this.dataLab;

        return {
          doctor: staff?.name || '-',
          guarantorType,
          timeOrder: `${moment(timestamps.created_at)
            .locale('id')
            .format('dddd, Do MMMM YYYY, HH:mm:ss')}`,
          timeFinish: `${
            timestamps.finished_at
              ? moment(timestamps.finished_at)
                  .locale('id')
                  .format('dddd, Do MMMM YYYY, HH:mm:ss')
              : '-'
          }`,

          name: patient?.name || '-',
          address: this.formatAddress(patient?.address),
          gender: patient?.gender === 'L' ? 'Laki - Laki' : 'Perempuan' || '-',
          birthDateAge: patient?.birthDate
            ? `${patient.birthDate} / ${patient.age} thn`
            : '-',
          noLabRM: orderNumber ? `${orderNumber} / ${patient?.rmNumber}` : '-',

          clinicalNotes: clinical_notes || '',
          recommendation: recommendation || '',
          testItem: test_item,
          timestamps: timestamps.created_at,
        };
      } else {
        const { meta, rmNumber } = this.patientData;
        const {
          code,
          timestamps,
          clinical_notes,
          recommendation,
          test_item,
          staff,
        } = this.labByReqId;

        return {
          doctor: staff?.name || '-',
          guarantorType: meta?.guarantorType || '-',
          timeOrder: `${moment(timestamps.created_at)
            .locale('id')
            .format('dddd, Do MMMM YYYY, h:mm:ss')}`,
          timeFinish: `${
            timestamps.finished_at
              ? moment(timestamps.finished_at)
                  .locale('id')
                  .format('dddd, Do MMMM YYYY, h:mm:ss')
              : '-'
          }`,

          name: meta?.name || '-',
          address: meta?.address || '-',
          gender: meta?.gender || '-',
          birthDateAge: meta?.birthDate
            ? `${meta.birthDate} / ${meta.age} thn`
            : '-',
          noLabRM: `${code} / ${rmNumber || '-'}`,

          clinicalNotes: clinical_notes || '',
          recommendation: recommendation || '',
          testItem: test_item,
        };
      }
    },
    printResult() {
      const data = this.dataPrint();
      const doc = this.printLabResult({
        doctor: data.doctor,
        guarantorType: data.guarantorType,
        timeOrder: data.timeOrder,
        timeFinish: data.timeFinish,
        name: data.name,
        address: data.address,
        gender: data.gender,
        birthDateAge: data.birthDateAge,
        noLabRM: data.noLabRM,
        testItem: data.testItem,
        clinicalNotes: data.clinicalNotes,
        recommendation: data.recommendation,
        timestamps: data.timestamps,
        staff_request: this.labResult.staff_request.isDoctor
          ? this.labResult.staff_request.name
          : '-',
      });
      this.printDocument(doc, {
        docName: 'Hasil Laboratorium',
        rmNumber: data.noLabRM,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.heightFull {
  height: 90vh;
}

.heightNotFull {
  height: 80vh;
}
.card-layout {
  .title {
    font-weight: bold !important;
    padding-bottom: 0 !important;
  }
  &__header {
    position: sticky;
  }
  .container-layout {
    overflow: auto;
    width: 98%;
    &::-webkit-scrollbar {
      width: 3px;
      background-color: grey;
    }
    &::-webkit-scrollbar-thumb {
      width: 3px;
      background-color: black;
    }
  }
}

.header {
  .label {
    margin-right: 1rem !important;
    color: #9e9e9e;
  }
  .data {
    margin-right: 1.8rem !important;
  }
}

.detail-header {
  gap: 1rem;
  padding: 2rem 4rem 0 4rem;
}
.card-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.card-footer {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1rem 4rem !important;
}
.text-key {
  font-size: 12px;
  font-weight: 400;
  color: #9e9e9e;
}
.text-value {
  font-size: 12px;
  font-weight: 400;
  color: #404040;
}
</style>
